module.exports = require("../../pdfmake/vfs_fonts");


// WEBPACK FOOTER //
// pdfmake/vfs_fonts"